/* This file is autogenerated, see readme.md for instructions */
import StartSvgIcon from '@bloomreach/banana-theme/icons/start.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const StartIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <StartSvgIcon />
    </Icon>
  );
});

StartIcon.displayName = 'StartIcon';

export default StartIcon;
